export enum ActionOverRecordTypes {
    MultipleRecord = 'multipleRecord',
    OverTable = 'overTable',
    SingleRecord = 'singleRecord',
}